export const removedRTBFields = [
  'adtype',
  'vast',
  'js',
  'vastConnectionMode',
  'fixedPrice',
  'has_new_iab_categories',
  'is_rewarded'
];

export const checkboxesRTB = [
  'active',
  'isSecure',
  'isBanner',
  'isNative',
  'popRespXml',
  'rewarded',
  'isAudio',
  'mobile_web',
  'mobile_app',
  'desktop',
  'ctv',
  'isVideo',
  'botman_enable_postbid',
  'botman_enable_prebid',
  'fraud_sensor_enable_postbid',
  'media_guard_enable_prebid',
  'fraud_logix_enable_postbid',
  'is_iurl_filter',
  'useTMT',
  'usePMKey',
  'is_pixalate_postbid',
  'useGeoedge',
  'useBcatFilter',
  'has_badv_filter',
  'gzipResponses',
  'has_response_adomain',
  'has_demand_booster',
  'has_maximised_bidprice',
  'use_secure_filter',
  'is_gpp_support',
  'usePMPrebid',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'isForTest',
  'is_origin_device_object',
  'is_default_coppa',
  'is_flexible_size_matching',
  'use_geo_from_ip',
];

export const removedVastFields = [
  'isBanner',
  'isNative',
  'popRespXml',
  'adtype',
  'defaultBidfloor',
  'js',
  'useBcatFilter',
  'is_gpp_support',
  'has_badv_filter',
  'has_demand_booster',
  'is_iurl_filter',
  'has_new_iab_categories',
  'useTMT',
  'usePMKey',
  'usePMPrebid',
  'rtbConnectionMode'
];

export const vastCheckboxes = [
  'active',
  'ctv',
  'desktop',
  'gzipResponses',
  'mobile_app',
  'isAudio',
  'isVideo',
  'rewarded',
  'isSecure',
  'fixedPrice',
  'has_response_adomain',
  'is_pixalate_postbid',
  'botman_enable_postbid',
  'botman_enable_prebid',
  'fraud_sensor_enable_postbid',
  'media_guard_enable_prebid',
  'fraud_logix_enable_postbid',
  'mobile_web',
  'dc_subnet',
  'def_app',
  'domain',
  'hr_app',
  'ifa',
  'ip',
  'ott',
  'ua',
  'useTMT',
  'use_secure_filter',
  'has_maximised_bidprice',
  'usePMKey',
  'useGeoedge',
  'usePMPrebid',
  'isForTest',
  'is_origin_device_object',
  'is_default_coppa',
  'is_flexible_size_matching',
  'use_geo_from_ip',
  'is_rewarded'
];

export const preBidCheckboxes = [
  'active',
  'isSecure',
  'isBanner',
  'isNative',
  'isAudio',
  'isVideo',
  'popRespXml',
  'rewarded',
  'mobile_web',
  'mobile_app',
  'desktop',
  'ctv',
  'botman_enable_postbid',
  'botman_enable_prebid',
  'fraud_sensor_enable_postbid',
  'media_guard_enable_prebid',
  'fraud_logix_enable_postbid',
  'is_gpp_support',
  'useTMT',
  'usePMKey',
  'is_pixalate_postbid',
  'useGeoedge',
  'useBcatFilter',
  'gzipResponses',
  'has_badv_filter',
  'use_secure_filter',
  'has_response_adomain',
  'has_demand_booster',
  'is_iurl_filter',
  'has_maximised_bidprice',
  'usePMPrebid',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'isForTest',
  'is_origin_device_object',
  'is_default_coppa',
  'is_flexible_size_matching',
  'use_geo_from_ip',
];

export const removedPreBidFields = [
  'adtype',
  'vast',
  'js',
  'vastConnectionMode',
  'fixedPrice',
  'has_new_iab_categories',
  'rtbConnectionMode',
  'is_rewarded'
];

export const jsCheckboxes = [
  'active',
  'isSecure',
  'mobile_web',
  'mobile_app',
  'desktop',
  'fixedPrice',
  'gzipResponses',
  'has_badv_filter',
  'has_response_adomain',
  'has_demand_booster',
  'has_maximised_bidprice',
  'use_secure_filter',
  'useGeoedge',
  'botman_enable_postbid',
  'botman_enable_prebid',
  'fraud_sensor_enable_postbid',
  'media_guard_enable_prebid',
  'fraud_logix_enable_postbid',
  'usePMKey',
  'useTMT',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'isForTest',
  'is_origin_device_object',
  'is_default_coppa',
  'is_flexible_size_matching',
  'use_geo_from_ip',
];

export const removedJsFields = [
  'vastConnectionMode',
  'ctv',
  'adtype',
  'vast',
  'defaultBidfloor',
  'apiLink',
  'usePMPrebid',
  'useBcatFilter',
  'isBanner',
  'isNative',
  'isAudio',
  'isVideo',
  'popRespXml',
  'is_gpp_support',
  'is_iurl_filter',
  'rewarded',
  'defaultBidfloor',
  'useBcatFilter',
  'has_badv_filter',
  'jsAdType',
  'adapter_id',
  'is_pixalate_postbid',
  'has_new_iab_categories',
  'useTMT',
  'usePMKey',
  'usePMPrebid',
  'rtbConnectionMode',
  'vastConnectionMode',
  'is_rewarded',
  'iab_bcat'
];

export const checkboxesForUpdateForm = [
  'active',
  'isSecure',
  'isBanner',
  'isNative',
  'popRespXml',
  'rewarded',
  'isAudio',
  'mobile_web',
  'mobile_app',
  'desktop',
  'isForTest',
  'is_gpp_support',
  'ctv',
  'isVideo',
  'fixedPrice',
  'botman_enable_postbid',
  'botman_enable_prebid',
  'fraud_sensor_enable_postbid',
  'fraud_logix_enable_postbid',
  'useTMT',
  'usePMKey',
  'is_pixalate_postbid',
  'useGeoedge',
  'usePMPrebid',
  'useBcatFilter',
  'has_badv_filter',
  'gzipResponses',
  'has_response_adomain',
  'has_demand_booster',
  'is_iurl_filter',
  'has_maximised_bidprice',
  'use_secure_filter',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'active',
  'has_response_adomain',
  'is_origin_device_object',
  'is_default_coppa',
  'is_flexible_size_matching',
  'use_geo_from_ip',
  'is_rewarded'
];

export const rtbDSPCheckboxes = [
  'active',
  'useAdapter',
  'mismatchedIpFilter',
  'mismatchedBundlesFilters',
  'is_only_with_consent',
  'sChain',
  'isSspSchain',
  'schain_source',
  'is_ssp_schain_source',
  'is_schain_complete',
  'drop_empty_schain',
  'is_dual_schain',
  'is_custom_sellers_json',
  'is_authorized_schain',
  'ipv4_required',
  'ccpa_check',
  'is_pixalate_postbid',
  'has_badv_limit',
  'has_iab_categories_limit',
  'is_omsdk',
  'is_compress_outgoing_requests',
  'deviceIdRequired',
  'allow_synth_ifa',
  'withPlacementOnly',
  'banner',
  'native',
  'video',
  'rewarded',
  'mobileWeb',
  'inApp',
  'desktop',
  'ctv',
  'audio',
  'iabOttCtv',
  'useTCF',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'botman_enable_postbid',
  'fraud_sensor_enable_postbid',
  'fraud_logix_enable_postbid',
  'dc_subnet',
  'is_requests_empty_appname',
  'mraid_impression_pixel',
  'exclude_mraid_response',
  'is_pchain',
  'is_display_manager',
  'exclude_mraid_response',
  'is_coppa_filtration',
  'exclude_mraid_response',
  'is_undefined_state_allowed',
  'is_lmt_and_dnt_filter',
  'is_display_manager',
];

export const removedRtbDSPFields = [
  'defaultPriceVast',
  'js',
  'selectedSize',
  'selectedPreBidServer',
  'id',
  'vastConnectionMode',
  'adServerId',
  'is_store_url',
  'adtype',
];

export const vastDSPCheckboxes = [
  'active',
  'useAdapter',
  'mismatchedIpFilter',
  'mismatchedBundlesFilters',
  'is_only_with_consent',
  'sChain',
  'isSspSchain',
  'schain_source',
  'is_ssp_schain_source',
  'is_schain_complete',
  'drop_empty_schain',
  'is_dual_schain',
  'is_custom_sellers_json',
  'is_authorized_schain',
  'ipv4_required',
  'ccpa_check',
  'botman_enable_postbid',
  'fraud_sensor_enable_postbid',
  'fraud_logix_enable_postbid',
  'is_pixalate_postbid',
  'has_badv_limit',
  'has_iab_categories_limit',
  'is_omsdk',
  'is_compress_outgoing_requests',
  'mobileWeb',
  'inApp',
  'desktop',
  'ctv',
  'video',
  'audio',
  'rewarded',
  'deviceIdRequired',
  'allow_synth_ifa',
  'withPlacementOnly',
  'iabOttCtv',
  'useTCF',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'is_store_url',
  'is_coppa_filtration',
  'is_undefined_state_allowed',
  'is_lmt_and_dnt_filter',
  'is_pchain',
];

export const removedVastDSPFields = [
  'js',
  'selectedSize',
  'selectedPreBidServer',
  'nurl',
  'id',
  'banner',
  'native',
  'is_requests_empty_appname',
  'exclude_mraid_response',
  'mraid_impression_pixel',
  'rtbConnectionMode',
  'is_display_manager',
  'adtype',
];

export const preBidDSPCheckboxes = [
  'active',
  'useAdapter',
  'mismatchedIpFilter',
  'mismatchedBundlesFilters',
  'is_only_with_consent',
  'sChain',
  'isSspSchain',
  'schain_source',
  'is_ssp_schain_source',
  'is_schain_complete',
  'drop_empty_schain',
  'is_dual_schain',
  'is_custom_sellers_json',
  'is_authorized_schain',
  'ipv4_required',
  'ccpa_check',
  'botman_enable_postbid',
  'fraud_sensor_enable_postbid',
  'fraud_logix_enable_postbid',
  'is_pixalate_postbid',
  'has_badv_limit',
  'has_iab_categories_limit',
  'is_omsdk',
  'is_compress_outgoing_requests',
  'banner',
  'native',
  'video',
  'rewarded',
  'mobileWeb',
  'inApp',
  'desktop',
  'ctv',
  'deviceIdRequired',
  'allow_synth_ifa',
  'withPlacementOnly',
  'iabOttCtv',
  'useTCF',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'is_requests_empty_appname',
  'exclude_mraid_response',
  'mraid_impression_pixel',
  'is_coppa_filtration',
  'mraid_impression_pixel',
  'is_undefined_state_allowed',
  'is_lmt_and_dnt_filter',
  'is_pchain',
  'is_display_manager',
];

export const removedPreBidDSPFields = [
  'defaultPriceVast',
  'js',
  'audio',
  'selectedSize',
  'id',
  'endpoint',
  'adServerId',
  'vastConnectionMode',
  'rtbConnectionMode',
  'is_store_url',
  'adtype',
];

export const jsDSPCheckboxes = [
  'active',
  'useAdapter',
  'mismatchedIpFilter',
  'mismatchedBundlesFilters',
  'is_only_with_consent',
  'sChain',
  'isSspSchain',
  'schain_source',
  'is_ssp_schain_source',
  'is_schain_complete',
  'drop_empty_schain',
  'is_dual_schain',
  'is_custom_sellers_json',
  'is_authorized_schain',
  'ipv4_required',
  'ccpa_check',
  'is_pixalate_postbid',
  'has_badv_limit',
  'has_iab_categories_limit',
  'is_omsdk',
  'is_compress_outgoing_requests',
  'mobileWeb',
  'inApp',
  'desktop',
  'deviceIdRequired',
  'allow_synth_ifa',
  'withPlacementOnly',
  'iabOttCtv',
  'useTCF',
  'ip',
  'ifa',
  'botman_enable_postbid',
  'fraud_sensor_enable_postbid',
  'fraud_logix_enable_postbid',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'is_store_url',
  'is_coppa_filtration',
  'is_undefined_state_allowed',
  'is_lmt_and_dnt_filter',
  'is_pchain',
];

export const removedJsDSPFields = [
  'banner',
  'native',
  'video',
  'audio',
  'rewarded',
  'ctv',
  'pixalate_pb_settings',
  'rtb_type',
  'mismatchedIpFilter',
  'mismatchedBundlesFilters',
  'iabOttCtv',
  'pmPrebidSuspiciousIVT',
  'adServerId',
  'is_requests_empty_appname',
  'exclude_mraid_response',
  'mraid_impression_pixel',
  'vastConnectionMode',
  'rtbConnectionMode',
  'is_display_manager',
  'adtype',
];

export const checkboxesForUpdateDSPForm = [
  'active',
  'useAdapter',
  'sChain',
  'isSspSchain',
  'schain_source',
  'is_ssp_schain_source',
  'is_schain_complete',
  'drop_empty_schain',
  'is_dual_schain',
  'is_custom_sellers_json',
  'is_authorized_schain',
  'banner',
  'native',
  'video',
  'rewarded',
  'audio',
  'mobileWeb',
  'inApp',
  'desktop',
  'ctv',
  'mismatchedIpFilter',
  'mismatchedBundlesFilters',
  'iabOttCtv',
  'useTCF',
  'is_only_with_consent',
  'ccpa_check',
  'deviceIdRequired',
  'allow_synth_ifa',
  'withPlacementOnly',
  'is_omsdk',
  'is_compress_outgoing_requests',
  'ipv4_required',
  'has_badv_limit',
  'has_iab_categories_limit',
  'is_pixalate_postbid',
  'botman_enable_postbid',
  'fraud_sensor_enable_postbid',
  'fraud_logix_enable_postbid',
  'is_requests_empty_appname',
  'ip',
  'ifa',
  'ua',
  'ott',
  'def_app',
  'domain',
  'hr_app',
  'dc_subnet',
  'exclude_mraid_response',
  'mraid_impression_pixel',
  'is_store_url',
  'is_coppa_filtration',
  'is_undefined_state_allowed',
  'is_lmt_and_dnt_filter',
  'is_pchain',
  'is_display_manager',
];
